import useFocusTrap from 'hooks/useFocusTrap';

const FocusTrap = ({ children, shouldFocusFirstElement }) => {
  const ref = useFocusTrap({ shouldFocusFirstElement });
  return (
    <div ref={ref}>
      {children}
    </div>
  );
};

export default FocusTrap;
